import * as Clipboard from "expo-clipboard";
import { useClipboard } from "use-clipboard-copy";

import Toast from "react-native-toast-message";
import { useCallback } from "react";
import { Platform } from "react-native";
import { t } from "@/localization";

// expo-clipboard's synchronous setString was removed in Expo SDK 55 (calling it threw and
// crashed the app on every copy button); setStringAsync works on iOS, Android and web.
// A failed copy is logged, never an unhandled rejection.
export const copyToClipboard = (value) =>
  Clipboard.setStringAsync(String(value ?? "")).catch((error) => {
    console.warn("Copy to clipboard failed", error);
    return false;
  });

const useClipboardCallback = () => {
  const clipboard = useClipboard({
    copiedTimeout: 1000,
  });

  return useCallback(
    (value) => {
      if (Platform.OS === "web") {
        clipboard.copy(value);
      } else {
        copyToClipboard(value);
      }
      Toast.show({
        text1: t("Copied"),
        type: "success",
      });
    },
    [clipboard]
  );
};

export default useClipboardCallback;
